import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { Toaster } from '../components/ui'

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <>
      <Outlet />
      <Toaster />
    </>
  ),
  notFoundComponent: () => (
    <div className="grid min-h-dvh place-items-center p-6 text-center">
      <div>
        <p className="text-5xl font-bold text-brand">404</p>
        <p className="mt-2 text-ink-2">That page doesn't exist.</p>
        <a href="/" className="mt-4 inline-block font-semibold text-brand">Go to dashboard</a>
      </div>
    </div>
  ),
})
